import {
  GETList, 
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/payment-term/v1";

export const getPaymentTerm = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createPaymentTerm(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getPaymentTermAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function getPaymentTermDetail(id) {
  return GETDetail(API_URL, id);
}

export function editPaymentTerm(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archivePaymentTerm(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchivePaymentTerm(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deletePaymentTerm(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}